import { Component, Input, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import * as Sentry from '@sentry/angular';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { CatalogPaginationRequest } from 'src/app/features/shared/models/CatalogPagination/CatalogPaginationRequest';
import { FilterRequest } from 'src/app/features/shared/models/Filter/FilterRequest';
import { SwalNotificationService } from 'src/app/features/shared/services/SwalNotification.service';
import { DownloadsCenterService } from '../../service/DownloadsCenter.service';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import { ToastrService } from 'ngx-toastr';

import { environment } from "src/environments/environment";

@Component({
  selector: 'downloads-table',
  templateUrl: './downloads-table.component.html',
  styleUrls: ['./downloads-table.component.css']
})
export class DownloadsTableComponent {

  dummyDownloads = [
    {
      Id: 'a1b2c3d4-e5f6-7890-abcd-1234567890ab',
      CreatedBy: 'usuario1@email.com',
      CreatedIn: '01/09/2025',
      TypeMapixDownloadRequest: 'Reporte de Historicos',
      StatusMapixDownloadRequest: 'Terminado'
    },
    {
      Id: 'b2c3d4e5-f6a7-8901-bcde-2345678901bc',
      CreatedBy: 'usuario2@email.com',
      CreatedIn: '02/09/2025',
      TypeMapixDownloadRequest: 'Estadisticas de manejo',
      StatusMapixDownloadRequest: 'En proceso'
    },
    {
      Id: 'c3d4e5f6-a7b8-9012-cdef-3456789012cd',
      CreatedBy: 'usuario3@email.com',
      CreatedIn: '03/09/2025',
      TypeMapixDownloadRequest: 'Habitos de conducción',
      StatusMapixDownloadRequest: 'Error'
    },
    {
      Id: 'd4e5f6a7-b8c9-0123-def0-4567890123de',
      CreatedBy: 'usuario4@email.com',
      CreatedIn: '04/09/2025',
      TypeMapixDownloadRequest: 'Reporte de Historicos',
      StatusMapixDownloadRequest: 'Terminado'
    },
    {
      Id: 'e5f6a7b8-c9d0-1234-ef01-5678901234ef',
      CreatedBy: 'usuario5@email.com',
      CreatedIn: '05/09/2025',
      TypeMapixDownloadRequest: 'Habitos de conducción',
      StatusMapixDownloadRequest: 'En proceso'
    },
    {
      Id: 'f6a7b8c9-d0e1-2345-f012-6789012345f0',
      CreatedBy: 'usuario6@email.com',
      CreatedIn: '06/09/2025',
      TypeMapixDownloadRequest: 'Historico Global',
      StatusMapixDownloadRequest: 'Error'
    },
    {
      Id: 'a7b8c9d0-e1f2-3456-0123-789012345601',
      CreatedBy: 'usuario7@email.com',
      CreatedIn: '07/09/2025',
      TypeMapixDownloadRequest: 'Habitos de conducción',
      StatusMapixDownloadRequest: 'Terminado'
    },
    {
      Id: 'b8c9d0e1-f2a3-4567-1234-890123456712',
      CreatedBy: 'usuario8@email.com',
      CreatedIn: '08/09/2025',
      TypeMapixDownloadRequest: 'Reporte de Historicos',
      StatusMapixDownloadRequest: 'En proceso'
    },
    {
      Id: 'c9d0e1f2-a3b4-5678-2345-901234567823',
      CreatedBy: 'usuario9@email.com',
      CreatedIn: '09/09/2025',
      TypeMapixDownloadRequest: 'Habitos de conducción',
      StatusMapixDownloadRequest: 'Error'
    },
    {
      Id: 'd0e1f2a3-b4c5-6789-3456-012345678934',
      CreatedBy: 'usuario10@email.com',
      CreatedIn: '10/09/2025',
      TypeMapixDownloadRequest: 'Historico Global',
      StatusMapixDownloadRequest: 'Terminado'
    }
  ];

  @Input() tableData;
    @Input() columnHeader;
    @Input() filterOptions: { [key: string]: string[] };
    @Input() catalogPaginationRequest: CatalogPaginationRequest;
  
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) mainPaginator!: MatPaginator;
    @ViewChild(MatPaginator) noFilterPaginatorBackup!: MatPaginator;
  
  
    objectKeys = Object.keys;
    mainDataSource: MatTableDataSource<any>;
    noFilterDataSourceBackup: MatTableDataSource<any>;
    public isLoading = true;
    routeAdd: string;
    routeUpdate: string;
    routeDelete: string;
    mainTotalCount: number;
    filterTotal: number;
    pagina: number = 1;
    filterPage: number = 1;
    filterValue: string = "";
    filtroInput: string = "";
    currentColumn: string;
    filterSearchText: string = '';
  
    subscription_GetLoading: Subscription;
    subscription_getPage: Subscription;
    subscription_getFilterCount: Subscription;
    subscription_delete: Subscription;
    subscription_getLogById: Subscription;
    constructor(
      private notifyService: SwalNotificationService,
      private toastr: ToastrService,
      private router: Router,
      private service: DownloadsCenterService
    ) {
    }
  
    ngOnInit() {
      this.isLoading = true;
    }
  
    ngAfterViewInit() {
    }
  
    ngOnDestroy() {
      if (this.subscription_getPage) 
        this.subscription_getPage.unsubscribe();
      if (this.subscription_getFilterCount) 
        this.subscription_getFilterCount.unsubscribe();
      if (this.subscription_delete) 
        this.subscription_delete.unsubscribe();
      if (this.subscription_getLogById) 
        this.subscription_getLogById.unsubscribe();
    }
  
    public setData(data, mainTotalCount) {
      if(!environment.production) console.log("Data tabla", data, mainTotalCount);
  
      this.mainTotalCount = mainTotalCount;
      this.mainPaginator.length = this.mainTotalCount;
      this.tableData = this.GetCapitalizedKeys(data);
      this.mainDataSource = new MatTableDataSource(this.tableData);
      this.mainDataSource.paginator = this.mainPaginator;
      this.mainDataSource.sort = this.sort;
      this.isLoading = false;
      this.noFilterDataSourceBackup = this.mainDataSource;
      this.noFilterPaginatorBackup = this.mainPaginator;
  
      if(!environment.production) console.log("Data", this.mainDataSource);
      
    }
  
    GetCapitalizedKeys(data){
      return data.map(item => {
        const transformedItem = {};
        Object.keys(item).forEach(key => {
          transformedItem[key.charAt(0).toUpperCase() + key.slice(1)] = item[key];
        });
        return transformedItem;
      });
    }
  
    async nextPage(event){
      //revisa si va a traer datos filtrados
      if( (this.catalogPaginationRequest.dato != null && this.catalogPaginationRequest.dato != "") || this.catalogPaginationRequest.filters.length > 0){
        if ((event.pageIndex + 1) > this.filterPage){
          this.isLoading = true;
          this.catalogPaginationRequest.page = (event.pageIndex + 1);
          await this.UpdatePage();
          this.mainPaginator.length = this.filterTotal;
          this.mainDataSource.paginator = this.mainPaginator;
          this.mainDataSource.sort = this.sort;
          setTimeout(() => {
            this.mainPaginator.length = this.filterTotal;
          });
          this.isLoading = false;
          this.filterPage++;
        }
      }else{
        if ((event.pageIndex + 1) > this.pagina ){
          this.isLoading = true;
          this.catalogPaginationRequest.page = (event.pageIndex + 1);
          await this.UpdatePage();
          this.mainPaginator.length = this.mainTotalCount;
          this.mainDataSource.paginator = this.mainPaginator;
          this.mainDataSource.sort = this.sort;
          setTimeout(() => {
            this.mainPaginator.length = this.mainTotalCount;
          });
          this.isLoading = false;
  
          this.noFilterDataSourceBackup = this.mainDataSource;
          this.noFilterPaginatorBackup = this.mainPaginator;
          this.pagina++;
        }
        
      }
    }
  
    async UpdatePage(): Promise<void> {
      const capitalizedNewData = this.GetCapitalizedKeys(this.dummyDownloads);
      this.mainDataSource = new MatTableDataSource(this.mainDataSource.data.concat(capitalizedNewData));
      // try {
      //   const data = await firstValueFrom(this.service.getPage(this.catalogPaginationRequest));

      //   if (data.isSuccess) {
      //     const capitalizedNewData = this.GetCapitalizedKeys(data.result);
      //     this.mainDataSource = new MatTableDataSource(this.mainDataSource.data.concat(capitalizedNewData));
      //   } else {
      //     this.notifyService.MessageError("Error en la carga de datos");
      //     this.isLoading = false;
      //     throw new Error("Error en la carga de datos");
      //   }
      // } catch (err) {
      //   console.error("Error en getPage", err);
      //   throw err;
      // }
    }

  
    async applyFilter(event : any = null) {
      var keyPressed = null;
      if (event != null){
        keyPressed = event.code;
      }else{
        keyPressed = "Enter";
      }
      if (keyPressed != "Enter" && this.filtroInput.length > 0)
        return;
      
      this.isLoading = true;
      if (this.filtroInput.length >= 2) {
          //se actualiza el request de paginacion
          this.catalogPaginationRequest.page = 1;
          this.catalogPaginationRequest.dato = this.filtroInput;
          await this.GetFilterFirstPage();
      }
      else{
        this.catalogPaginationRequest.dato = "";
        this.removeFilter();
        this.isLoading = false;
      }
      if (this.mainDataSource.paginator)
        this.mainDataSource.paginator.firstPage();
      
    } 
  
    async GetFilterFirstPage(){
      this.subscription_getFilterCount = this.service.getCount(this.catalogPaginationRequest).subscribe({
        next: (data) => {
          if (data.isSuccess == true) {
            this.filterTotal = data.result[0];
          }else{
            Sentry.captureMessage('DownloadsTable.GetFilterFirstPage: conteo filtrado sin éxito', { level: 'warning', extra: { response: data } });
            console.error('Error al obtener conteo filtrado');
          }
        },
        error: (error) => {
          // TODO marca para complete despues
          console.error('Error al obtener conteo filtrado', error);
        }
      });
      this.mainDataSource = new MatTableDataSource([]);
      await this.UpdatePage();
      this.mainDataSource.paginator = this.mainPaginator;
      this.mainDataSource.sort = this.sort; 
      setTimeout(() => {
        this.mainPaginator.length = this.filterTotal;
      });
      this.isLoading = false;
      this.filterPage = 1;
    }
  
    removeFilter(){
      const filterValue = this.filtroInput;
      if (filterValue.length == 0) {
        this.isLoading = true;
        this.mainDataSource = this.noFilterDataSourceBackup;
        this.mainPaginator = this.noFilterPaginatorBackup;
        setTimeout(() => {
          this.mainPaginator.length = this.mainTotalCount;
        });
        this.filterPage = 0;
      }
      this.isLoading = false;
      if (this.mainDataSource.paginator) {
        this.mainDataSource.paginator.firstPage();
      }
    }
    
  
    refreshFilter(){
      this.filtroInput = "";
      this.catalogPaginationRequest.dato = "";
      this.catalogPaginationRequest.filters = [];
      this.applyFilter();
    }
  
    setCurrentColumn(column: string) {
      this.currentColumn = column;
    }
  
    applyColumnFilter(value: string) {
      const filter: FilterRequest = { key: this.currentColumn, value: value };
      var currentFilter = this.catalogPaginationRequest.filters.find(filter => filter.key === this.currentColumn);
      if (currentFilter) {
        currentFilter.value = value;
      }
      else {
        this.catalogPaginationRequest.filters.push(filter);
      }
      this.columnHeader[this.currentColumn].activeFilter = value;
      this.applyFilter();
    }
  
    clearColumnFilter() {
      this.catalogPaginationRequest.filters = this.catalogPaginationRequest.filters.filter(filter => filter.key !== this.currentColumn);
      this.columnHeader[this.currentColumn].activeFilter = null;
      this.applyFilter();
    }
  
    downloadReport(row) {
      if(!environment.production) console.log("Descargar reporte", row);
      
      if(row != null && row.StatusMapixDownloadRequest === 'Terminado') {
        const workSheet = XLSX.utils.aoa_to_sheet([
              ['Ejemplo de reporte'],
              ['ID', 'Creado por', 'Fecha de creación', 'Tipo de reporte', 'Estatus del reporte'],
              [row.Id, row.CreatedBy, row.CreatedIn, row.TypeMapixDownloadRequest, row.StatusMapixDownloadRequest]
            ]);
            const wscols = [{ wpx: 300 }];
            workSheet['!cols'] = wscols;
          
            const workBook: XLSX.WorkBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workBook, workSheet, 'Hoja1');
            XLSX.writeFile(workBook, `${row.TypeMapixDownloadRequest} ${row.CreatedIn}.xlsx`);
      }else if(row.StatusMapixDownloadRequest === 'Error') {
        this.notifyService.MessageError('Hubo un error al generar el reporte. Por favor, contacta al soporte');
      }
    }


}
